import React, {useState} from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { format } from 'date-fns';
import DatePicker from "react-datepicker"
import moment from "moment";
import { useCookies } from 'react-cookie';
import DatePicker2 from '../InputField/DatePicker/DatePicker2';
import axios from 'axios'


const Notice = ({sendnotice, props, shouldload, completedmodal}) => {
    const [currdate, setCurrdate] = useState()
    const [schedule, setSchedule] = useState(true)
    const [cookies] = useCookies(['Token']);
    const API = 'https://staging.sabrecwa.com'

    const handleClose = () =>{
        sendnotice({
            action: "close",
            text: ''
        })   
    }

    const [dates, setDates] = useState({
        startDate: "",
        endDate: ""
    })

    // const handleDateSelect = (e) =>{
    //     setDates({...dates, startdate: format(e, 'yyyy/MM/dd')})
    // }

    const handleDateSelect = (date) =>{
        setDates({...dates, startDate: moment(date).format('YYYY-MM-DD hh:mm:ss a')})
        setCurrdate(moment(date).format('MM-DD-YYYY'))
    }

    const handleendDateSelect = (date) =>{
        setDates({...dates, endDate: moment(date).format('YYYY-MM-DD hh:mm:ss a')})
    }
    
    const handleBroadcast = () =>{
        setSchedule(false)
    }

    const SendBroadcast = async () =>{
        // sendnotice("broadcast")
        sendnotice({
            action: "close",
            text: ''
        })  

        shouldload(true)
        let objct ={
            name: 'Performance Appraisal Boradcast',
            ...dates
        }
        setSchedule(true)


        try {
            var config = {
              method: 'POST',
              url: `${API}/hr/create/appraisal`,
              data: objct,
              headers: { 
                Authorization: "Bearer " + cookies.Token
              }
            };
  
            // console.log(config)
        
            await axios(config).then((response) => {
                // console.log(response.data.data);
                if(response.data.success === true){
                    sendnotice({
                        action: "notload",
                        text: 'Appraisal Schedule Set Successfully!'
                    })  
                    completedmodal(false)
                }
            });
        } catch(e){
            if(e.message.includes('401')){
              // catch error
              sendnotice({
                action: "error",
                text: ''
            })}
        }
    }

  return (
    <div className='overlay-container'>
            <div className='overlay-real-container'>
                <div className='top-container-apprais-notif'>
                    <span>CREATE APPRAISAL NOTIFICATION</span>
                    <AiOutlineCloseCircle id='closeIcon-notifc' onClick={handleClose}/>
                </div>

                <div className='top-appraisal-container-body'>
                    <div className='top-appraisal-column1'>
                        <span>Start Date</span>
                        <input className='start-inputfield' placeholder='start date' value={dates.startDate}/>
                        <DatePicker2 linestate={true} selected={handleDateSelect} start={true} currentdate={currdate}/>
                    </div>
                    <div className='top-appraisal-column2'>
                        <span>End Date</span>
                        <input className='start-inputfield' placeholder='End date' value={dates.endDate}/>
                        <DatePicker2 linestate={true} selected={handleendDateSelect} start={false} currentdate={currdate}/>
                    </div>
                    <div className='top-appraisal-submit-row'>
                        <button id={schedule ? 'broadcast-buttn' : 'inactv'} onClick={SendBroadcast}>BROADCAST</button>
                        <button id={schedule ? 'inactv' : 'broadcast-buttn'} onClick={handleBroadcast}>SCHEDULE</button>
                    </div>

                </div>
            </div>
        </div>
  )
}

export default Notice